import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

import { StolenCamerasComponent } from "./stolencameras.component";
import { StolenCamerasService, StolenCameraConfigService, IStolenCameraConfigService } from "./stolencameras.service";
import { StolenCameraDetailComponent } from "./stolencameradetail.component";
import { TranslateModule } from "@ngx-translate/core";
import { OAuthModule } from "@impacgroup/angular-oauth-base";
import { Route, RouterModule } from "@angular/router";
import { StolenCamerasMainComponent } from "./stolencameras.main.component";
import { StandardCountryService } from "../../global/services/country.service";

@NgModule({
    declarations: [StolenCamerasMainComponent, StolenCamerasComponent, StolenCameraDetailComponent],
    imports: [CommonModule, RouterModule, FormsModule, BsDropdownModule, ModalModule, NgSelectModule, TranslateModule, OAuthModule, MatTableModule, MatPaginatorModule, MatSortModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    exports: [],
    providers: []
})
export class StolenCamerasModule {
    static forRoot(stolenCameraConfig: IStolenCameraConfigService): ModuleWithProviders<StolenCamerasModule> {
        // returns the services as singletons throughout the app (for lazy loading purposes)
        return {
            ngModule: StolenCamerasModule,
            providers: [
                StandardCountryService,
                StolenCamerasService,
                {
                    provide: StolenCameraConfigService,
                    useValue: stolenCameraConfig
                }
            ]
        };
    }

    static getRoutes(): Route[] {
        return [
            {
                path: "",
                component: StolenCamerasMainComponent,
                children: [
                    {
                        path: "",
                        component: StolenCamerasComponent
                    },
                    {
                        path: "add/:cameraId",
                        component: StolenCameraDetailComponent
                    },
                    {
                        path: ":id",
                        component: StolenCameraDetailComponent
                    }
                ]
            }
        ];
    }
}
